import React from 'react';
import PropTypes from 'prop-types';
import { Col, Radio, Row } from 'antd';
import HireItems from '../../../components/HireItems';
import OffHireReminder from '../../../components/OffHireReminder';
import history from '../../../core/utils/history';

const ExpandedRow = ({ selectedAction, record, settings, setSelectedAction, setSelectedRecord }) => (
    <Row>
        <Col>
            <Row>
                <HireItems siteId={record?.siteId} />
            </Row>
            <Row>
                <div className="action-button-group">
                    <Radio.Group value={selectedAction} onChange={(e) => { if (e.target.value === 'view-full-details') { history.push(`/account/hire-contracts/${record.contractNo}`); } else { setSelectedAction(e.target.value); setSelectedRecord(record); } }}>
                        <Radio.Button size="small" value="view-full-details">View Full Details</Radio.Button>
                        <Radio.Button size="small" value="order-again">Order Again</Radio.Button>
                        {record.status === 'On Hire' && (
                            <>
                                {settings.change_po_number_enabled && <Radio.Button value="change-po-number">Change PO Number</Radio.Button>}
                                <Radio.Button
                                    data-order-id={record.id}
                                    data-web-id={record.contractNo}
                                    className={`off-hire-reminder-action-${record.id}`}
                                    value="off-hire-reminder">
                                    Set Off-Hire Reminder
                                </Radio.Button>
                                <Radio.Button value="request-exchange">Request Exchange</Radio.Button>
                                {record.webId && <Radio.Button value="off-hire">Off-Hire</Radio.Button>}
                            </>
                        )}

                    </Radio.Group>
                </div>
                <OffHireReminder actionId={`.off-hire-reminder-action-${record.id}`} />
            </Row>
        </Col>
    </Row>
);

ExpandedRow.propTypes = {
    selectedAction: PropTypes.string.isRequired,
    record: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
    setSelectedAction: PropTypes.func.isRequired,
    setSelectedRecord: PropTypes.func.isRequired,
};

export default ExpandedRow;
